<template>
  <div class="content-documents-status col-md-12">
    <div class="row">
      <div class="content-status col-md-12">
        <!--<h2>Verificação</h2>
        <ul>
            <li>
              <div v-b-tooltip.hover.html="tipDataBackgroundCheck" :class="data.verification.backgroundCheck === 'OK' ? 'icon success' : data.verification.backgroundCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-fingerprint"></i></div> CPF
            </li>
            <li>
              <div v-b-tooltip.hover.html="tipDataCreditCheck" :class="data.verification.creditCheck === 'OK' ? 'icon success' : data.verification.creditCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-credit-card-2"></i></div> Crédito
            </li>
            <li>
              <div v-b-tooltip.hover.html="tipDataIdCheck" :class="data.verification.idCheck === 'OK' ? 'icon success' : data.verification.idCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-link-3"></i></div> Cadastro
            </li>
            <li>
              <div v-b-tooltip.hover.html="tipDataFaceCheck" :class="data.verification.faceCheck === 'OK' ? 'icon success' : data.verification.faceCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-user-circle"></i></div> Selfie
            </li>
            <li>
              <div v-b-tooltip.hover.html="tipDataAddressCheck" :class="data.verification.addressCheck === 'OK' ? 'icon success' : data.verification.addressCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-location-2"></i></div> Endereço
            </li>
            <li>
              <div :class="data.verification.socialLoginCheck === 'OK' ? 'icon success' : data.verification.socialLoginCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-like"></i></div> Rede social
            </li>
        </ul>-->

        <div class="item-container">
          <h2>Verificação</h2>
          <button variant="primary" @click="changeVerificationCollapse()">
            <i :class="verificationCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i>
          </button>
          <div class="button-text">{{ verificationCollapse ? 'Fechar' : 'Abrir' }}</div>
          <table class="table table-responsive-md" v-if="!verificationCollapse">
            <thead>
              <tr>
                <th class="table-title-validators"><span>Validadores</span></th>
                <th><i class="icon-fingerprint mr-1 icon-table" :class="data.verification.backgroundCheck === 'OK' ? 'icon success' : data.verification.backgroundCheck === 'REVIEW' ? 'icon warning' : data.verification.backgroundCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>CPF</th>
                <th><i class="icon-credit-card-2 mr-1 icon-table" :class="data.verification.creditCheck === 'OK' ? 'icon success' : data.verification.creditCheck === 'REVIEW' ? 'icon warning' : data.verification.creditCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Crédito</th>
                <th><i class="icon-link-3 mr-1 icon-table" :class="data.verification.idCheck === 'OK' ? 'icon success' : data.verification.idCheck === 'REVIEW' ? 'icon warning' : data.verification.idCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Cadastro</th>
                <th><i class="icon-user-circle mr-1 icon-table" :class="data.verification.faceCheck === 'OK' ? 'icon success' : data.verification.faceCheck === 'REVIEW' ? 'icon warning' : data.verification.faceCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Selfie</th>
                <th><i class="icon-location-2 mr-1 icon-table" :class="data.verification.addressCheck === 'OK' ? 'icon success' : data.verification.addressCheck === 'REVIEW' ? 'icon warning' : data.verification.addressCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Endereço</th>
              </tr>
            </thead>
          </table>
          <table class="table table-responsive-md" v-else>
            <thead>
              <tr>
                <th class="table-title-validators"><span>Validadores</span></th>
                <th><i class="icon-fingerprint mr-1 icon-table" :class="data.verification.backgroundCheck === 'OK' ? 'icon success' : data.verification.backgroundCheck === 'REVIEW' ? 'icon warning' : data.verification.backgroundCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>CPF</th>
                <th><i class="icon-credit-card-2 mr-1 icon-table" :class="data.verification.creditCheck === 'OK' ? 'icon success' : data.verification.creditCheck === 'REVIEW' ? 'icon warning' : data.verification.creditCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Crédito</th>
                <th><i class="icon-link-3 mr-1 icon-table" :class="data.verification.idCheck === 'OK' ? 'icon success' : data.verification.idCheck === 'REVIEW' ? 'icon warning' : data.verification.idCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Cadastro</th>
                <th><i class="icon-user-circle mr-1 icon-table" :class="data.verification.faceCheck === 'OK' ? 'icon success' : data.verification.faceCheck === 'REVIEW' ? 'icon warning' : data.verification.faceCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Selfie</th>
                <th><i class="icon-location-2 mr-1 icon-table" :class="data.verification.addressCheck === 'OK' ? 'icon success' : data.verification.addressCheck === 'REVIEW' ? 'icon warning' : data.verification.addressCheck === 'ERROR' ? 'icon danger' : 'icon disabled'"></i>Endereço</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tableData" v-bind:key="row.name" class="tr-validators">
                <th scope="row">{{row.name}}</th>
                <td :class="row.results.data.background_check === 'OK' ? 'icon success' : row.results.data.background_check === 'REVIEW' ? 'icon warning' : row.results.data.background_check === 'ERROR' ? 'icon danger' : 'icon disabled'">
                  <div class="td-container-validators">
                    <span>{{row.results.data.background_check !== '' ? row.results.data.background_check : '-'}}</span>
                  </div>
                </td>
                <td :class="row.results.data.credit_check === 'OK' ? 'icon success' : row.results.data.credit_check === 'REVIEW' ? 'icon warning' : row.results.data.credit_check === 'ERROR' ? 'icon danger' : 'icon disabled'">
                  <div class="td-container-validators">
                    <span>{{row.results.data.credit_check !== '' ? row.results.data.credit_check : '-'}}</span>
                  </div>
                </td>
                <td :class="row.results.data.id_check === 'OK' ? 'icon success' : row.results.data.id_check === 'REVIEW' ? 'icon warning' : row.results.data.id_check === 'ERROR' ? 'icon danger' : 'icon disabled'">
                  <div class="td-container-validators">
                    <span>{{row.results.data.id_check !== '' ? row.results.data.id_check : '-'}}</span>
                  </div>
                </td>
                <td :class="row.results.data.face_check === 'OK' ? 'icon success' : row.results.data.face_check === 'REVIEW' ? 'icon warning' : row.results.data.face_check === 'ERROR' ? 'icon danger' : 'icon disabled'">
                  <div class="td-container-validators">
                    <span>{{row.results.data.face_check !== '' ? row.results.data.face_check : '-'}}</span>
                    <div :class="row.results.data.face_check_reason === ' • SEM CNH' ? 'margin-left-validators div-td-validators' : 'div-td-validators'">{{row.results.data.face_check_reason}}</div>
                  </div>
                </td>
                <td :class="row.results.data.address_check === 'OK' ? 'icon success' : row.results.data.address_check === 'REVIEW' ? 'icon warning' : row.results.data.address_check === 'ERROR' ? 'icon danger' : 'icon disabled'">
                  <div class="td-container-validators">
                    <span>{{row.results.data.address_check !== '' ? row.results.data.address_check : '-'}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="content-document" :class="resizeClass" ref="containerImageWidth" v-resize="containerImageResize">
        <h2>Documentos
          <!-- <button class="information" @click="createVerification">
            <div v-if="loading" class="spinner-border spinner-border-sm split-loading" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <i v-else class="icon-plus"></i>
          </button>
          <span class="split-message">{{ splitMessage ? 'Link enviado' : '' }}</span> -->
        </h2>
        <viewer>
          <carousel :per-page="2" :navigate-to="someLocalProperty" :mouse-drag="true">
            <template v-if="objMediaDocuments.length">
              <slide v-for="i in objMediaDocuments.slice(0).reverse()" v-bind:key="i.id">
                  <img class="VueCarousel-image" :src="i.media" :style="{ minWidth: `${containerWidth}px`, objectFit: 'cover' }"/>
                <div class="label">{{ i.source }}</div>
              </slide>
            </template>
            <template v-else>
              <slide>
                <div class="slide-default">
                  <div>Aguardando documento</div>
                </div>
              </slide>
              <slide>
                <div class="slide-default">
                  <div>Aguardando documento</div>
                </div>
              </slide>
            </template>
          </carousel>
        </viewer>
      </div>
      <div class="content-selfie" :class="resizeClass">
        <h2>Selfie <div :class="data.verification.faceCheck === 'OK' ? 'icon success' : data.verification.faceCheck === 'REVIEW' ? 'icon warning' : 'icon danger'"><i class="icon-user-circle"></i></div></h2>
        <viewer>
          <carousel :per-page="2" :navigate-to="someLocalProperty" :mouse-drag="true">
            <template v-if="objMediaSelfie.length">
              <slide v-for="i in objMediaSelfie.slice(0).reverse()" v-bind:key="i.id">
                <!-- <template v-if="i.type.includes('image')"> -->
                <!-- Acima e comentado, modelo amplo que aceita image/gif, image/png, image/jpeg, image/bmp, image/webp -->
                <!-- Abaixo, modelo engessado que resolveu de forma objetiva os casos da AME -->
                <template v-if="i.type === 'image/png' || i.type === 'image/jpeg'">
                  <img class="VueCarousel-image" :src="i.media" :style="{ minWidth: `${containerWidth}px`, objectFit: 'cover' }" />
                </template>
                <video v-else :src="i.media" :width="containerWidth" height="130" controls />
                <div class="label">{{ i.source }}</div>
              </slide>
            </template>
            <template v-else>
              <slide>
                <div class="slide-default">
                  <div>Aguardando Selfie</div>
                </div>
              </slide>
              <slide>
                <div class="slide-default">
                  <div>Aguardando Selfie</div>
                </div>
              </slide>
            </template>
          </carousel>
        </viewer>
      </div>
      <div class="content-link col-md-12">
        <div class="icon-text-link-container" v-if="returnShortenUrl(this.validation)">
          <div class="icon information">
            <i class="icon-link-1"></i>
          </div>
          <div class="text-link-container" v-if="returnShortenUrl(this.validation)">
            <a class="info-link" target="_blank" :href="returnShortenUrl(validation)">{{returnShortenUrl(validation)}}</a>
            <div class="info-last-send">Último envio em {{getLastSend(validation) | moment-month}} às {{getLastSend(validation) | moment-hour}}h</div>
          </div>
        </div>
          <div class="buttons-container">
            <button :class="disableButton ? 'btn-send-link' : 'btn-send-link disable'" @click="createVerification" id="tooltip-send-link" :disabled="disableButton">
                <span v-if="!loading">Reenviar link</span>
              <div v-else class="spinner-border spinner-border-sm send-message-loading" role="status">
              </div>
            </button>
            <b-tooltip class="send-link-tooltip" :show.sync="showTooltip" target="tooltip-send-link" triggers="click">
              Link enviado
            </b-tooltip>
            <button class="btn-dropdown" @click="toggleLinkDropdown" v-if="getLastSend(this.validation)">
              <i class="icon-arrow-1-down"></i>
            </button>
              <div class="menu-link-info" :class="{'open': stateLinkMenu}">
                <ul v-show="stateLinkMenu" v-if="getLastSend(this.validation)">
                  <li class="last-send-info">Última mensagem enviada em {{getLastSend(validation) | moment-date}} às {{getLastSend(validation) | moment-hour}}h</li>
                </ul>
                <ul v-show="stateLinkMenu" v-for="v in returnFilteredValidationArray(this.validation).reverse()" :key="v.transactionValidationFilesId">
                  <li >Mensagem enviada em {{v.dateCreated | moment-date}} às {{v.dateCreated | moment-hour}}h</li>
                </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import resize from 'vue-resize-directive'
import 'viewerjs/dist/viewer.css'
import moment from 'moment-timezone'

export default {
  directives: {
    resize
  },
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      data: [],
      validation: [],
      objMediaDocuments: [],
      objMediaSelfie: [],
      containerWidth: null,
      splitMessage: null,
      verificationCollapse: false,
      loading: false,
      creatingVerification: false,
      stateLinkMenu: false,
      showTooltip: false,
      disableButton: false,
      actualDate: null,
      lastDateCreated: null,
      diffDate: null,
      endereco: '',
      interval: 0,
      validationData: [],
      backgroundCheck: '',
      creditCheck: '',
      idCheck: '',
      faceCheck: '',
      addressCheck: '',
      tipDataBackgroundCheck: { title: '' },
      tipDataCreditCheck: { title: '' },
      tipDataIdCheck: { title: '' },
      tipDataFaceCheck: { title: '' },
      tipDataAddressCheck: { title: '' },
      splitUrl: null,
      validationKA: [],
      resultsArr: [],
      tableData: []
    }
  },

  mounted () {
    this.getCustomerVerification()
    this.loadValidation()
    this.interval = setInterval(() => {
      this.handleDisableButton(this.validation)
    }, 10000)
    this.loadValidationData()
    // this.getTableData()
  },
  methods: {

    changeVerificationCollapse () {
      this.verificationCollapse = !this.verificationCollapse
    },
    // getTableData: function () {
    //   this.$http.get('api/validations/' + this.$route.params.txid + '/data')
    //     .then(function (res) {
    //       console.log(res)
    //     })
    //     .catch(function (res) {
    //       console.log(res)
    //     })
    // },
    async loadValidation () {
      await this.$http.get('api/validations/' + this.$route.params.txid + '/data')
        .then(function (res) {
          this.validation = res.data.validations
          this.returnShortenUrl(this.validation)
          // console.log('TENTATIVAAQUI' + JSON.stringify(this.validation, null, 2))

          if (!this.lastDateCreated) {
            this.lastDateCreated = moment(new Date(this.getLastSend(this.validation)))
            this.actualDate = new Date()
          }
          this.handleDisableButton(this.validation)
        })
        .catch(function (res) {
          // console.log('ERROR request whatsapp')
          // console.log(res)
        })
    },
    getCustomerVerification () {
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-verification')
        .then(function (res) {
          this.data = res.data
          // console.log(this.data)
          this.$emit('backgroundCheckStatus', this.data.verification.backgroundCheck)
          this.$emit('addressCheckStatus', this.data.verification.addressCheck)
          this.data.data.forEach(obj => {
            if (!this.creatingVerification) {
              this.splitMessage = obj.whatsappMessage
              obj.media.forEach(media => {
                if (media.title === 'selfie' || media.title === 'videoSelfie') {
                  this.objMediaSelfie.push({
                    source: obj.name,
                    media: media.data,
                    type: media.type
                  })
                } else {
                  this.objMediaDocuments.push({
                    source: obj.name,
                    media: media.data,
                    type: media.type
                  })
                }
              })
            }
          })

          if (this.creatingVerification) {
            this.$emit('emit-split-message', true)
            this.openWhatsapp()
            this.creatingVerification = false
          }
        })
        .catch(function (res) {
          // console.log('Error')
          // console.log(res)
        })
    },
    async resendLink () {
      await this.$http.get('api/transactions/' + this.$route.params.txid)
        .then(function (res) {
          this.splitUrl = this.returnShortenUrl(this.validation)
          this.$http.post('api/chat/split', {splitUrl: this.splitUrl, phone: this.customerPhoneNumber})
            .then(function (res) {
              this.$root.$emit('updateWhatsappMessages')
            })
            .catch(function (res) {
              console.log('Error')
              console.log(res)
              this.loading = false
            })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.loading = false
        })
    },
    async createVerification () {
      this.loading = true
      this.creatingVerification = true
      await this.$http.post('api/validations/' + this.$route.params.txid)
        .then(function (res) {
          this.handleDisableButton(this.validation)
          this.getCustomerVerification()
          this.loadValidation()
          this.handleToolTip()
          this.resendLink()
        })
        .catch(function (res) {
          // console.log('Error')
          // console.log(res)
          this.loading = false
          // this.msgErro = res.data
        })
    },
    openWhatsapp () {
      this.$emit('emitWhastappOpen')
      this.$emit('emitWhatsappScrollbar')
    },
    containerImageResize () {
      let width = this.$refs.containerImageWidth.clientWidth
      this.containerWidth = (width / 2) - 30
    },
    toggleLinkDropdown (e) {
      this.stateLinkMenu = !this.stateLinkMenu
    },
    getLastSend (arr) {
      let lastSend = arr.slice(-1).filter(e => e.shortenUrl)
      try {
        return lastSend[0].dateCreated
      } catch (e) {
        lastSend = null
        return lastSend
      }
    },
    handleToolTip () {
      setTimeout(() => {
        this.showTooltip = false
      }, 1500)
    },
    handleValidationArray (arr) {
      if (arr.length > 5) {
        return arr.slice(1, 5)
      } else {
        return arr
      }
    },
    handleDisableButton (arr) {
      if (this.lastDateCreated) {
        this.lastDateCreated = moment(new Date(this.getLastSend(arr))).add(5, 'minutes')
        this.actualDate = new Date()
        this.diffDate = this.lastDateCreated.diff(this.actualDate, 'minutes')
      }
    },
    loadValidationData () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/data')
        .then(function (res) {
          this.validationData = res.data
          // console.log(this.validationData)
          if (this.validationData.validations[0]) {
            // console.log(this.validationData.validations[1])

            this.tableData = this.validationData.validations

            this.validationData.validations.forEach(v => {
              if (v.results.data) {
                this.backgroundCheck += '<div class="teste">'
                this.creditCheck += '<div class="text-left">'
                this.idCheck += '<div class="text-left">'
                this.faceCheck += '<div class="text-left">'
                this.addressCheck += '<div class="text-left">'
                // console.log(v.results.data)
                v.results.data.forEach(r => {
                  this.resultsArr.push({
                    name: v.name,
                    status: r.status,
                    step: r.step
                  })
                  if (r.step === 'background_check') {
                    if (!this.backgroundCheck.includes('background_check')) this.backgroundCheck += `<div><b>${r.step}</b><br/>`
                    this.backgroundCheck += `${v.name}: <b>${r.status}</b><br/></div>`
                  }

                  if (r.step === 'credit_check') {
                    if (!this.creditCheck.includes('credit_check')) this.creditCheck += `<b>${r.step}</b><br/>`
                    this.creditCheck += `${v.name}: <b>${r.status}</b><br/>`
                  }

                  if (r.step === 'id_check') {
                    if (!this.idCheck.includes('id_check')) this.idCheck += `<b>${r.step}</b><br/>`
                    this.idCheck += `${v.name}: <b>${r.status}</b><br/>`
                  }

                  if (r.step === 'face_check') {
                    if (!this.faceCheck.includes('face_check')) this.faceCheck += `<b>${r.step}</b><br/>`
                    this.faceCheck += `${v.name}: <b>${r.status}</b><br/>`
                  }

                  if (r.step === 'address_check') {
                    if (!this.addressCheck.includes('address_check')) this.addressCheck += `<b>${r.step}</b><br/>`
                    this.addressCheck += `${v.name}: <b>${r.status}</b><br/>`
                  }
                })

                this.backgroundCheck += '</div>'
                this.idCheck += '</div>'
                this.faceCheck += '</div>'
                this.addressCheck += '</div>'
              }
            })
            // console.log(this.resultsArr)
            this.tipDataBackgroundCheck = { title: this.backgroundCheck }
            this.tipDataCreditCheck = { title: this.creditCheck }
            this.tipDataIdCheck = { title: this.idCheck }
            this.tipDataFaceCheck = { title: this.faceCheck }
            this.tipDataAddressCheck = { title: this.addressCheck }
          }
        })
        .catch(function (res) {
          // console.log('Error')
          // console.log(res)
        })
    },

    returnShortenUrl (arr) {
      try {
        console.log('ARR aqui-> ' + arr)
        this.splitUrl = arr.slice(1, arr.length, -1).find((e) => {
          console.log(e.shortenUrl)
          console.log('url aqui -> ' + e.shortenUrl)
          return e.shortenUrl
        }).shortenUrl
      } catch (e) {
        this.splitUrl = null
      }
      return this.splitUrl
    },
    returnFilteredValidationArray (arr) {
      arr = this.validation.slice(1, this.validation.length - 1).filter(e => e.shortenUrl)
      return arr
    }
  },
  watch: {
    'loadingLink' () {
      if (this.loading) {
        this.loading = this.loadingLink
      }
    }
  },

  props: ['resizeClass', 'customerPhoneNumber', 'customerName', 'customerSteps', 'seller', 'loadingLink']
}
</script>

<style lang="scss">
.item-container {
  .font-attempts {
    font-weight: 500;
    color: #666666;
  }

  .icon-table {
    background: none;
  }
  table {
    max-height: 300px;
    border-collapse: separate;
    border-spacing: 6px;

    thead {
      .theadValidation{
        background: none;
        font-weight: 700;
        text-align: left;
      }
        th {
          border-top: none;
          border-bottom: none;
        }
      }

    tr:first-child {
      td {
        border-top: none;
        border-bottom: none;
      }
    }

    td {
      padding: 0px;
      border-top: none;
      border-bottom: none;
    }
    span {
  padding: 2px 10px;
  border-radius: 4px;
  width: 100%;
  display: inline-block;
  text-align: center;
  font-weight: 600;
  }
    th {
    width: 130px;
    text-align: center;
    font-weight: 500;
    font-family: Poppins;
    color: #666666;
    background: #F6F6F6;
    border-radius: 5px;
    padding: 4px 4px;
    border-bottom: none;
  }
  }

  table tr td {
    width: 130px;
  }
  h2 {
    color: #666666;
    margin: 0;
    float: left;
  }
  button {
    width: 24px;
    height: 24px;
    float: right;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-top: -4px;
    padding: 0px;
    border: none;
    background: rgba(66, 133, 244, 0.2);
    color: #4285F4;
    outline: none;
  }
  .button-text {
    float: right;
    line-height: 1.4em;
    color: rgba(66, 133, 244, 0.75);
    margin-right: 4px;
  }
  .collapsing {
    transition: none !important;
  }
}

.content-documents-status {
  float: left;
  .content-document, .content-selfie {
    float: left;
    h2 {
      margin-top: 24px;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 12px;
        }
      }
      .split-loading {
        margin-left: 2px;
        color: #4285F4;
        font-size: 5px;
      }
    }
    .VueCarousel {
      .VueCarousel-wrapper {
        height: 130px;
        .VueCarousel-inner {
          height: 130px !important;
          .VueCarousel-slide {
            cursor: pointer;
            .VueCarousel-image {
              height: 130px;
              width: 95%;
              overflow: hidden;
              border-radius: 8px;
              margin: 0 5px;
              background-size: cover;
              background-repeat: no-repeat;
              background-repeat: no-repeat;
              background-position: center;
            }
            video {
              width: 95%;
              overflow: hidden;
              border-radius: 8px;
              margin: 0px 0px -5px 5px;
              background-color: #000000;
            }
            .slide-default {
              height: 130px;
              width: 95%;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 8px;
              margin: 0 5px;
              background-color: #FAFAFA;
              text-align: center;
            }
            &:hover {
              .label {
                position: relative;
                bottom: 30px;
                width: 95%;
                height: 30px;
                border-radius: 0 0 8px 8px;
                margin: 0 5px;
                padding: 5px;
                background-color: rgba(0, 0, 0, 0.75);
                text-align: center;
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .VueCarousel-pagination {
        .VueCarousel-dot-container {
          margin-top: 0 !important;
          .VueCarousel-dot {
            width: 8px !important;
            height: 8px !important;
            padding: 4px !important;
            outline: none;
            background-color: #CCCCCC !important;
            &.VueCarousel-dot--active {
              background-color: #4285F4 !important;
            }
          }
        }
      }
    }
  }
  .content-status {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-flex;
        align-items: center;
        margin-right: 16px;
        margin-bottom: 8px;
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          margin-right: 4px;
          text-align: center;
          border-radius: 50%;
          i {
            line-height: 2;
          }
        }
      }
    }
  }
  .split-message {
    font-weight: normal;
    margin-left: 5px;
    font-size: 0.8rem;
    color: #41BD64;
  }
  .hide {
    display: none;
  }
  .content-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
    gap: 1rem;

    .icon-text-link-container {
      display: flex;
      align-items: center;

      .text-link-container {
      font-family: "Poppins", sans-serif;
      display: flex;
      flex-direction: column;
      gap: .5rem;

        .info-link {
          font-size: 10px;
          color: #4285F4;
        }

        .info-last-send {
          font-size: 10px;
          color: #999999;
          font-style: italic;

        }

      }

      .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          margin-right: 6px;
          text-align: center;
          border-radius: 50%;

          i {
            font-size: 16px;
          }
        }
    }
    .buttons-container {
      background-color: #1c56e0;
      border-radius: 5px;
      display: flex;

      .btn-send-link {
        height: 32px;
        padding: 5px 14px;
        border: none;
        background-color: #1c56e0;
        font-size: 12px;
        color: #ffffff;
        line-height: 12px;

        &:disabled {
          background-color: #E5E5E5;
          color: #B0B0B0;
          border-radius: 5px 0 0 5px;
        }

      }
      .btn-dropdown {
        display: flex;
        align-items: center;
        height: 32px;
        background-color: #1c56e0;
        font-size: 12px;
        color: #ffffff;
        border: none;
        border-left: 1px solid #1948b6 ;
        border-radius: 0 5px 5px 0;

        i {
          font-size: 18px;
        }
      }
      .menu-link-info {
        position: absolute;
        margin-top: 2.5rem;
        border: 1px solid #F9F9F9;
        border-radius: 4px;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
        background-color: #FFFFFF;
        z-index: 10;
        left: 2.5rem;
        ul {
          padding: 8px 0;
          margin: 0;
          li {
            padding: 8px 16px;
            list-style: none;
            border-bottom: 1px solid #F9F9F9;
            display: content;
            color:#999999;
            font-style: italic;
            font-size: 12px;

          }
          .last-send-info {
            color: #666666
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/VerifyCustomer.vue